/**
 * lib/files/cadFiles.mjs — TICKET-908. CAD / 3D-model / scan files the team and
 * clients share: Rhino, AutoCAD, neutral exchange formats, meshes and Polycam
 * exports.
 *
 * These are accepted by file EXTENSION, never by MIME: browsers report an empty
 * or junk type for them (Windows: .stl -> application/vnd.ms-pki.stl, .obj ->
 * application/x-tgif; .dxf/.dwg -> image/vnd.*, which would send them down the
 * photo pipeline). Once accepted they are stored and registered as opaque
 * binary (CAD_MIME) so nothing downstream treats them as an image or as text.
 *
 * Shared by the client capture flow (src/lib/capture) and the server registry
 * (lib/handlers/documents-registry.js) so the two can never drift.
 */
export const CAD_EXTENSIONS = new Set([
  // Rhino / Grasshopper
  '3dm', 'gh', 'ghx',
  // AutoCAD and 2D drawings
  'dxf', 'dwg',
  // Neutral CAD exchange
  'igs', 'iges', 'step', 'stp', 'sat', 'x_t', 'x_b', '3mf', 'skp',
  // Meshes / 3D models (incl. Polycam exports)
  'obj', 'mtl', 'stl', 'fbx', 'dae', 'glb', 'gltf', 'ply', 'usdz',
  // Point clouds / scans
  'las', 'laz', 'e57', 'pts', 'xyz',
]);

export const CAD_MIME = 'application/octet-stream';

export function isCadFileName(name) {
  if (typeof name !== 'string') return false;
  const dot = name.lastIndexOf('.');
  return dot >= 0 && CAD_EXTENSIONS.has(name.slice(dot + 1).toLowerCase());
}
